import React from 'react';
import '../../styles/PresentationHomogene.css';
import ImgGareTrooEt11 from '../../images/Petage1.jpg';
import RoseRonsard from '../../images/RoseRonsard.jpg';

const Petage = () => {
    return (
        <div className='presentation-section'>
            <div className='presentation-card'>
                <div className='section-header'>
                    <h1 className='section-title'>Premier Étage</h1>
                </div>
                
                <div className='section-content'>
                    <div className='section-image'>
                        <img src={ImgGareTrooEt11} alt="Premier étage - Exposition Ronsard" />
                    </div>
                    <div className='section-text'>
                        <p className='section-description'>
                            Au premier étage une balade poétique en vallée du Loir avec des vidéos, photos, scénographies... 
                            Vous y découvrirez le Loir, ses châteaux, les troglodytes, les fresques et Ronsard.
                        </p>
                    </div>
                    <div className='section-image'>
                        <img src={RoseRonsard} alt="Rose de Ronsard" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Petage;